import { rpaBridge } from '@/tauri/rpa';
import { isTauri } from '@/tauri/utils';
import { useUser } from '@heidi/workspace/data';
import { useQuery } from '@tanstack/react-query';

// UNCARVED DOMAIN KEY (rpa, CUA-44): rpa has no workspace package
export const DESKTOP_TARGET_INSTANCE_ID_QUERY_KEY = [
  'desktop-target-instance-id',
] as const;

export const readNativeInstanceId = async (): Promise<string | null> =>
  isTauri() && rpaBridge.isAvailable() ? rpaBridge.desktopTargetInstanceId() : null;

export const useNativeInstanceId = (enabled: boolean) => {
  const { data: userRefId } = useUser((user) => user?.user_ref_id);
  return useQuery({
    queryKey: [...DESKTOP_TARGET_INSTANCE_ID_QUERY_KEY, userRefId],
    queryFn: readNativeInstanceId,
    enabled: enabled && !!userRefId && isTauri() && rpaBridge.isAvailable(),
    retry: false,
  });
};
